import React, { createContext, useContext, useState } from 'react';
import { HeaderConfigComponentProps } from '../components/header/headerBasicLayout/HeaderBasicLayout';

interface HeaderContextType {
  headerConfig: HeaderConfigComponentProps;
  setHeaderConfig: (config: HeaderConfigComponentProps) => void;
}

const HeaderContext = createContext<HeaderContextType | undefined>(undefined);

export const useHeaderContext = () => {
  const context = useContext(HeaderContext);
  if (!context) {
    throw new Error('useHeaderContext must be used within a Provider');
  }
  return context;
};

export const HeaderProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [headerConfig, setHeaderConfig] = useState({});

  return (
    <HeaderContext.Provider value={{ headerConfig, setHeaderConfig }}>
      {children}
    </HeaderContext.Provider>
  );
};
